/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const SubmitScheduleSiteChangeRequest = zod.object({
  "id": zod.string().uuid(),
  "supervisorRemarks": zod.string().nullish()
});

export type SubmitScheduleSiteChangeRequest = zod.input<typeof SubmitScheduleSiteChangeRequest>;
export type SubmitScheduleSiteChangeRequestOutput = zod.output<typeof SubmitScheduleSiteChangeRequest>;
